import { AnyObject } from "core/types";

export const template = (templateString: string, object: AnyObject) =>
  Object.keys(object).reduce(
    (current, key) => current.replace(`{{${key}}}`, object[key]),
    templateString,
  );
